
import React from 'react'
import { connect } from 'react-redux'
// import { getInvestments } from 'services/user'
import Navigation from 'support/navigation'
import View from './View'
import i18n from 'support/i18n'
import { getGroups } from 'services/challenge_steps'
import { getInnovateChallenge,postInnovateChallengeImage,getChallengeIntoInnovateDraft,postInnovateChallengeCreate,putInnovateChallengeEdit,postInnovateChallengeDraft,getInnovateChallengeActiveTypes } from 'services/innovate/challenge'
import { getScorecardTemplatelist,getIdeaTemplatelist } from 'services/innovate/templates'
import {
  showPopupDialog,
  showPopupErrorSnackbar,
  showPopupSuccessSnackbar,
} from 'support/popup_dialogs'
import { hideDialog } from 'support/popup_dialogs/modal_alert_controller/ModalActions'
import ErrorSubmitModal from './dialogs/ErrorSubmitContainer'
import SuccessSubmitModal from './dialogs/SucessSubmitContainer'
import ConfirmSubmitModal from './dialogs/ConfirmSubmitContainer'
import { deleteInfoImageSaveDraft } from 'services/challenge_steps'
import { deleteInnovateChallengeImage } from 'services/innovate/challenge'
import { getSearchUserSuggestions } from 'services/user'

const mapStateToProps = state => {
  return {
    isOwner: state.data.createIdea.owner === state.data.user.userEmail,
    userEmail: state.data.user.userEmail,
    isAdmin: state.data.user.admin,
    isInnovator: state.data.user.isInnovator,
    ideas: state.data.user.investments.ideas,
    totalInvested: state.data.user.investments.totalInvested,
    totalProfit: state.data.user.investments.totalProfit,
    fullInfoLoaded: state.data.domain.dataLoaded,
    listCommunitesChallenge:state.data.InnovateChallenge.listInnovateCommunitesChallenge,
    editInnovateChallenge:state.data.InnovateChallenge.editInnovateChallenge,
    innovateCategoryTypes:state.data.InnovateChallenge.innovateCategoryTypes,
    draftInnovateChallenge:state.data.InnovateChallenge.DraftInnovateChallenge,
    draftGetInnovateChallengeLoading:state.data.InnovateChallenge.draftGetInnovateChallengeLoading,
    editInnovateChallengeLoading:state.data.InnovateChallenge.editInnovateChallengeLoading,
    getInnovateChallengeDraftIdAddImageLoading:state.data.InnovateChallenge.getInnovateChallengeDraftIdAddImageLoading,
    getInnovateChallengeDraftIdAddImage:state.data.InnovateChallenge.getInnovateChallengeDraftIdAddImage,
    getInnovateChallengeIdDetailsLoading:state.data.InnovateChallenge.getInnovateChallengeIdDetailsLoading,
    getInnovateChallengeIdDetails:state.data.InnovateChallenge.getInnovateChallengeIdDetails,
    createInnovateChallengeLoading:state.data.templates.createInnovateChallengeLoading,

    draftGetInnovateChallenge:state.data.InnovateChallenge.draftGetInnovateChallenge,
    listScorecardTemplate:state.data.templates.listScorecardTemplate,
    listIdeaTemplate:state.data.templates.listIdeaTemplate,
    draftIdForImage: state.data?.InnovateChallenge?.getInnovateChallengeIdDetails?.id,
    InnovateChallengeStatus:state.data?.InnovateChallenge?.getInnovateChallengeIdDetails?.status,
    csrfToken:state.auth.csrf,
    searchUserSuggestion: state.data.user.searchUserSuggestion,
    searchUserSuggestionsIsLoading:state.data.user.searchUserSuggestionsIsLoading,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    getInnovateChallengeFn: (challengeKeyId)=>{
      dispatch(getInnovateChallenge(challengeKeyId))
    },
    getScorecardTemplatelistFn: ()=>{
      dispatch(getScorecardTemplatelist())
    },
    getIdeaTemplatelistFn: ()=>{
      dispatch(getIdeaTemplatelist())
    },
    getInnovateChallengeActiveTypesFn: () => {
      dispatch(getInnovateChallengeActiveTypes())
    },
    // onTitleClick: id => {
    //   dispatch(Navigation.navigateToIdea(id))
    // },
    // navigateHome: () => dispatch(Navigation.navigateToExplore()),

    // postInnovateChallengeCreateFn : (createInnovateChallengeData,isAdminEmail)=>{
    //   const onSuccess = response => {
    //     showPopupDialog(<SuccessSubmitModal />, dispatch)
    //   }
    //   const onFailure = ({ data }) => {
    //     const messageTag =
    //       data && data.error && data.error.error
    //         ? `BACKEND_ERRORS.${data.error.error}`
    //         : 'BACKEND_ERRORS.UNEXPECTED'
    //     showPopupDialog(<ErrorSubmitModal description={i18n.t(messageTag)} />, dispatch)
    //   }

    //   dispatch(postInnovateChallengeCreate(createInnovateChallengeData,isAdminEmail, onSuccess, onFailure))
    //   // dispatch(createIdea(ownProps.formData, onSuccess, onFailure))
    //   dispatch(hideDialog())

    // },
    postInnovateChallengeCreateFn : (createInnovateChallengeData,isAdminEmail)=>{
      showPopupDialog(<ConfirmSubmitModal createInnovateChallengeData={createInnovateChallengeData} isAdminEmail={isAdminEmail} />, dispatch)
      // dispatch(postInnovateChallengeCreate(createInnovateChallengeData,isAdminEmail,))
    },
    putInnovateChallengeEditFn : (EditInnovateChallengeData)=>{
      const onSuccess = response => {
        showPopupDialog(<SuccessSubmitModal response={response} description='Your challenge is successfully updated!' />, dispatch)
      }
      const onFailure = ({ data }) => {
        const messageTag =
          // data && data.error && data.error.error
          //   ? `BACKEND_ERRORS.${data.error.error}`
          //   : 'BACKEND_ERRORS.UNEXPECTED'
          data && data.error 
          ? `${data.error.desc}`
          : 'BACKEND_ERRORS.UNEXPECTED'
        showPopupDialog(<ErrorSubmitModal description={messageTag} />, dispatch)
      }

      dispatch(putInnovateChallengeEdit(EditInnovateChallengeData, onSuccess,onFailure))
      dispatch(hideDialog())
    }, 
    saveDraftChallengeToBackend : (draftInnovateChallengeData,isAdminEmail)=>{
          const onSuccess = response => {
            showPopupDialog(<SuccessSubmitModal response={response} description='Your challenge draft is successfully Saved!' />, dispatch)
          }
          const onFailure = ({ data }) => {
            const messageTag =
              // data && data.error && data.error.error
              //   ? `BACKEND_ERRORS.${data.error.error}`
              //   : 'BACKEND_ERRORS.UNEXPECTED'
              data && data.error 
              ? `${data.error.desc}`
              : 'BACKEND_ERRORS.UNEXPECTED'
            showPopupDialog(<ErrorSubmitModal description={messageTag} />, dispatch)
          }
    
      dispatch(postInnovateChallengeDraft(draftInnovateChallengeData,isAdminEmail, onSuccess, onFailure))
      dispatch(hideDialog())
    },

    getCommunitesAsGroup : ()=> dispatch(getGroups()),
    navigateToProfile: () => dispatch(Navigation.navigateToProfile()),

    postInnovateChallengeImageFn : (IdKeyForImage,imageName)=>{
      const onSuccess = () =>{}
      const onFailure = () => {
        showPopupErrorSnackbar(i18n.t('BACKEND_ERRORS.UNEXPECTED'), dispatch)
      }
      dispatch(postInnovateChallengeImage(IdKeyForImage,imageName, onSuccess, onFailure))
    },
    deleteImageFn: (IdKeyForImage,imageName) => {
      const onFailure = errorResponse => {
        const { data } = errorResponse
        if (data && data.error && data.error.status === 400 && data.error.code === 2003) {
          showPopupErrorSnackbar(i18n.t('CHALLENGES.DELETE_IMAGE_ERROR'), dispatch)
        } else {
          showPopupErrorSnackbar(i18n.t('BACKEND_ERRORS.UNEXPECTED'), dispatch)
        }
      }
      dispatch(deleteInnovateChallengeImage(IdKeyForImage,imageName, onFailure))
    },
    getSearchUserFn:(useremail)=>{
      dispatch(getSearchUserSuggestions(useremail))
    }



  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(View)
